<template>
  <UiLogo
    :image-src="store.kiosk?.logo_url"
    :image-alt="store.kiosk?.client_name"
    :show-start-over-button="ui.showLogoStartOverButton"
    :start-over-label="$t('Logo.startOver')"
    :clickable="isClickable"
    @soft-restart="onSoftRestart"
    @hard-restart="onHardRestart"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { router } from '@/app/router';
// biome-ignore lint/correctness/noUnusedImports: used in <template> store.kiosk?.* expressions
import { store } from '@/app/store';
import { useUiStore } from '@/app/stores/ui';
// biome-ignore lint/correctness/noUnusedImports: used via tag <UiLogo> in <template>
import { UiLogo } from '@/ui-kit';

const ui = useUiStore();

const isClickable = computed(() => router.isStepPage);

async function onSoftRestart(): Promise<void> {
  if (ui.isLanguageSelectorOpen) {
    ui.hideLanguageSelector();
    return;
  }
  if (isClickable.value) {
    await ui.softRestart();
  }
}

async function onHardRestart(): Promise<void> {
  if (isClickable.value) {
    await ui.hardRestart();
  }
}
</script>
